import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { Controller, useForm } from 'react-hook-form';
import RoutesApp from '../../routes';
import dayjs from 'dayjs';

//Servicios
import { GuiasService } from '../../services/api';

//Modelos
import NewGuiaModel from '../../models/NewGuia';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import NewGuia from './NewGuia';
import ReactDatePicker from 'react-datepicker';

function NewGuiaContainer() {
    const {
        toast,
        masters,
        token,
        user,
        localeDateFormat,
        grapesVariety,
        Bodegas,
        buildSelectOptions,
        formatNumber,
        imageFileToBase64,
    } = useGlobalContext();
    const Navigate = useNavigate();
    const Params = useParams();

    const [loader, setLoader] = useState(false);
    const [OpenConfirmGuiaModal, setOpenConfirmGuiaModal] = useState(false);
    const [OpenDeleteGuiaModal, setOpenDeleteGuiaModal] = useState(false);
    const [GuiaData, setGuiaData] = useState(new NewGuiaModel());

    const FormMethods = useForm();

    const EstadoCreada = useMemo(() => {
        return GuiaData.cabecera?.estado === 0;
    }, [GuiaData]);
    const EstadoDestinatario = useMemo(() => {
        return GuiaData.cabecera?.estado === 1;
    }, [GuiaData]);
    const EstadoCerrada = useMemo(() => {
        return GuiaData.cabecera?.estado === 2;
    }, [GuiaData]);
    const CurrentBodega = FormMethods.watch('cabecera.bodega_Id');

    const ConfirmGuiaMessage = useMemo(() => {
        return (
            <div className="new_guia-modal-div">
                {EstadoDestinatario ? (
                    <p>
                        Al firmar, la carilla del destinatario de esta guía, ya
                        no podrá ser editada
                    </p>
                ) : (
                    <p>
                        Al firmar, usted está cerrando su ingreso de datos y la
                        guía pasará a modo “DESTINATARIO”. De haber elegido una
                        bodega, le enviaremos a esta un enlace para que complete
                        su parte.
                    </p>
                )}
                {EstadoDestinatario && (
                    <>
                        <label className="new_guia-label">
                            <input
                                {...FormMethods.register('cabecera.imagen', {})}
                                className="new_guia-upload_guia"
                                type="file"
                            />
                        </label>
                        <label className="new_guia-label">
                            <div>
                                <span>Fecha de Recepción: </span>
                                <Controller
                                    name="cabecera.fecha_Recepcion"
                                    control={FormMethods.control}
                                    render={() => (
                                        <ReactDatePicker
                                            dateFormat={'dd/MM/yyyy'}
                                            isClearable
                                            placeholderText="dd/mm/aaaa"
                                            locale={localeDateFormat}
                                            selected={
                                                FormMethods.getValues(
                                                    'cabecera.fecha_Recepcion'
                                                )
                                                    ? FormMethods.getValues(
                                                          'cabecera.fecha_Recepcion'
                                                      )
                                                    : null
                                            }
                                            onChange={(date) => {
                                                FormMethods.setValue(
                                                    'cabecera.fecha_Recepcion',
                                                    date
                                                );
                                                FormMethods.trigger();
                                            }}
                                        />
                                    )}
                                    rules={{
                                        required: {
                                            value: OpenConfirmGuiaModal,
                                            message:
                                                'Ingrese una fecha de recepción',
                                        },
                                        validate: {
                                            validDate: (v) =>
                                                new Date(v) <= new Date() ||
                                                'La fecha de recepeción no puede ser mayor a la actual',
                                        },
                                    }}
                                />
                            </div>
                            {FormMethods.formState.errors.cabecera
                                ?.fecha_Recepcion && (
                                <small className="form__error">
                                    {
                                        FormMethods.formState.errors.cabecera
                                            ?.fecha_Recepcion?.message
                                    }
                                </small>
                            )}
                        </label>
                    </>
                )}
                <label className="new_guia-label">
                    <div>
                        <span>Tipo Documento: </span>
                        <select
                            {...FormMethods.register(
                                EstadoDestinatario
                                    ? 'cabecera.doc_id_tipo_Destinatario'
                                    : 'cabecera.doc_id_tipo'
                            )}
                        >
                            {buildSelectOptions('DocumentTypes')?.map((op) => {
                                return (
                                    <option key={op.name} value={op.value}>
                                        {op.title}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </label>
                <label className="new_guia-label">
                    <div>
                        <span>Nro de Documento: </span>
                        <input
                            className="signup-input"
                            type="text"
                            {...FormMethods.register(
                                EstadoDestinatario
                                    ? 'cabecera.doc_id_Destinatario'
                                    : 'cabecera.doc_id',
                                {
                                    required: {
                                        value: OpenConfirmGuiaModal,
                                        message:
                                            'Debe ingresar número de documento',
                                    },
                                }
                            )}
                            onKeyPress={(e) => {
                                if (
                                    !/[A-Za-z0-9]+/.test(e.key) ||
                                    e.target.value.length > 15
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {EstadoDestinatario
                        ? FormMethods.formState.errors.cabecera
                              ?.doc_id_Destinatario && (
                              <small className="form__error">
                                  {
                                      FormMethods.formState.errors.cabecera
                                          ?.doc_id_Destinatario?.message
                                  }
                              </small>
                          )
                        : FormMethods.formState.errors.cabecera?.doc_id && (
                              <small className="form__error">
                                  {
                                      FormMethods.formState.errors.cabecera
                                          ?.doc_id?.message
                                  }
                              </small>
                          )}
                </label>
                <label className="new_guia-label">
                    <div>
                        <span>Firma Vitivinicultor: </span>
                        <input
                            type="text"
                            {...FormMethods.register(
                                EstadoDestinatario
                                    ? 'cabecera.firma_Destinatario'
                                    : 'cabecera.firma_Viticultor',
                                {
                                    required: {
                                        value: OpenConfirmGuiaModal,
                                        message: 'Debe firmar la guía',
                                    },
                                }
                            )}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 60) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {EstadoDestinatario
                        ? FormMethods.formState.errors.cabecera
                              ?.firma_Destinatario && (
                              <small className="form__error">
                                  {
                                      FormMethods.formState.errors.cabecera
                                          ?.firma_Destinatario?.message
                                  }
                              </small>
                          )
                        : FormMethods.formState.errors.cabecera
                              ?.firma_Viticultor && (
                              <small className="form__error">
                                  {
                                      FormMethods.formState.errors.cabecera
                                          ?.firma_Viticultor?.message
                                  }
                              </small>
                          )}
                </label>
                <footer>
                    <button
                        className="btn btn-primary"
                        onClick={FormMethods.handleSubmit(onSubmit)}
                    >
                        Firmar
                    </button>
                    <button
                        className="btn btn-secondary"
                        onClick={() => {
                            FormMethods.resetField('cabecera.firma_Viticultor');
                            setOpenConfirmGuiaModal(false);
                        }}
                    >
                        Cancelar
                    </button>
                </footer>
            </div>
        );
    }, [
        OpenConfirmGuiaModal,
        Object.keys(FormMethods.formState.errors.cabecera ?? {}).length,
    ]);

    const DeleteGuiaMessage = useMemo(() => {
        return (
            <div className="DJCE_visto-modal">
                <footer>
                    <button
                        className="btn btn-primary"
                        onClick={onSubmitDeleteGuia}
                    >
                        Aceptar
                    </button>
                    <button
                        className="btn btn-secondary"
                        onClick={() => setOpenDeleteGuiaModal(false)}
                    >
                        Cancelar
                    </button>
                </footer>
            </div>
        );
    }, [OpenDeleteGuiaModal]);

    useEffect(() => {
        async function fetchGuia() {
            try {
                setLoader(true);
                //Obtenemos la Guia segun el id de los params
                const Guia = await GuiasService.single({
                    token,
                    id: parseInt(Params.id),
                });
                if (Guia) {
                    //Establecemos los datos para la nueva Guia
                    const NewGuia = new NewGuiaModel(Guia.data);
                    setGuiaData(NewGuia);
                    //Establecemos los valores iniciales del form
                    NewGuia.itemsProductor.forEach((it, i) => {
                        NewGuia.itemsProductor[i][`kilos` + i] = it.kilos;
                        NewGuia.itemsProductor[i][`precio_Kg` + i] =
                            it.precio_Kg;
                    });
                    NewGuia.itemsBodega.forEach((it, i) => {
                        NewGuia.itemsBodega[i][`kilos` + i] = it.kilos;
                        NewGuia.itemsBodega[i][`grado_Gluc` + i] =
                            it.grado_Gluc;
                        NewGuia.itemsBodega[i][`precio_Kg` + i] = it.precio_Kg;
                    });
                    FormMethods.reset({ ...NewGuia });
                }
                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        }

        //Parche para que no se haga una peticion de mas a la api
        if (Object.keys(masters).length) fetchGuia();
    }, []);

    //Formamos la tabla con los datos del productor
    useEffect(() => {
        setItemsProductorTableData(
            buildItemsProductorTableData(GuiaData.itemsProductor)
        );
        setItemsBodegaTableData(
            buildItemsBodegaTableData(GuiaData.itemsBodega)
        );
    }, [GuiaData]);

    //Funcion para popular los titular, ubicacion y departamento de destinatario cuando se selecciona una bodega
    useEffect(() => {
        const SelectedBodega = Bodegas.find(
            (b) => b.id === parseInt(CurrentBodega)
        );
        const BodegaDepartment = masters?.Departments?.find(
            (d) =>
                d.nombre
                    .replace('_', ' ')
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '') ===
                SelectedBodega?.departamento
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
        )?.id;
        // console.log(BodegaDepartment);

        if (SelectedBodega) {
            FormMethods.setValue(
                'cabecera.titular_Destinatario',
                SelectedBodega?.razon_social || ''
            );
            FormMethods.setValue(
                'cabecera.ubicacion_Destinatario',
                SelectedBodega?.direccion || ''
            );
            FormMethods.setValue(
                'cabecera.departamento_Destinatario',
                BodegaDepartment || 0
            );
        }
    }, [CurrentBodega]);

    async function onSubmit(data) {
        // console.log(data);
        try {
            setLoader(true);

            //Parseamos la imagen a base64
            if (data.cabecera.imagen)
                data.cabecera.imagen = await imageFileToBase64(
                    data.cabecera.imagen[0]
                );

            //Formacion del objeto para enviar en la peticion
            const GuiaUpdated = new NewGuiaModel(data);
            GuiaUpdated.itemsProductor.forEach((it, i) => {
                it.kilos = parseInt(data.itemsProductor[i][`kilos` + i] || 0);
                it.precio_Kg = parseInt(
                    GuiaUpdated.itemsProductor[i][`precio_Kg` + i] || 0
                );
                delete GuiaUpdated.itemsProductor[i][`kilos` + i];
                delete GuiaUpdated.itemsProductor[i][`precio_Kg` + i];
            });
            GuiaUpdated.itemsBodega.forEach((it, i) => {
                it.kilos = parseInt(data.itemsBodega[i][`kilos` + i] || 0);
                it.grado_Gluc = parseFloat(
                    data.itemsBodega[i][`grado_Gluc` + i] || 0
                );
                it.precio_Kg = parseInt(
                    GuiaUpdated.itemsBodega[i][`precio_Kg` + i] || 0
                );
                delete GuiaUpdated.itemsBodega[i][`kilos` + i];
                delete GuiaUpdated.itemsBodega[i][`grado_Gluc` + i];
                delete GuiaUpdated.itemsBodega[i][`precio_Kg` + i];
            });
            //Peticion para actualizar la Guia
            const UpdateGuia = await GuiasService.update({
                token,
                guia: GuiaUpdated,
            });
            //Si la respuesta es correcta, navegamos denuevo a la tabla de guias y desplegamos mensaje de éxito
            if (UpdateGuia) {
                Navigate(RoutesApp.Guias.all);
                toast(
                    data.cabecera.firma_Viticultor
                        ? 'Guía enviada con éxito'
                        : 'Guía guardada con éxito',
                    { type: 'success' }
                );
                setOpenConfirmGuiaModal(false);
            }
            setLoader(false);
        } catch (err) {
            setLoader(false);
            toast('No se pudo guardar la guía', { type: 'error' });
            FormMethods.resetField('cabecera.firma_Viticultor');
            return err;
        }
    }

    async function onSubmitDeleteGuia() {
        try {
            setLoader(true);

            const DeleteGuia = await GuiasService.delete({
                token,
                guiaId: parseInt(Params.id),
            });

            if (DeleteGuia) {
                toast('Guía borrada con éxito', { type: 'success' });
                setOpenDeleteGuiaModal(false);
                setLoader(false);
                Navigate(RoutesApp.Guias.all);
            }
        } catch (err) {
            setLoader(false);
            setOpenDeleteGuiaModal(false);
            return err;
        }
    }

    /**Funcion que crea el objeto para pasarle a la tabla que lista los items del productor */
    const buildItemsProductorTableData = (
        data = [{ id: 0, variedad: 0, kilos: 0, aproxPrice: 0 }]
    ) => {
        return {
            title: `Uva enviada`,
            headers: ['Variedad de Uva', 'Kilos Probables', 'Precio por Kg'],
            pagination: 100,
            data: data?.map((dj, i) => {
                return {
                    variedad: grapesVariety?.find(
                        (gv) => gv.codigo === dj.variedad
                    )?.variedad,
                    kilos: (
                        <input
                            className="new_guia-table_input"
                            {...FormMethods.register(
                                `itemsProductor[${i}].kilos` + i
                            )}
                            type={'number'}
                            step="any"
                            disabled={EstadoDestinatario}
                        />
                    ),
                    aproxPrice: (
                        <input
                            className="new_guia-table_input"
                            {...FormMethods.register(
                                `itemsProductor[${i}].precio_Kg` + i
                            )}
                            type={'number'}
                            step="any"
                            disabled={EstadoDestinatario}
                        />
                    ),
                };
            }),
        };
    };

    const [ItemsProductorTableData, setItemsProductorTableData] = useState(
        buildItemsProductorTableData()
    );

    /**Funcion que crea el objeto para pasarle a la tabla que lista los items de la bodega */
    const buildItemsBodegaTableData = (
        data = [
            { id: 0, variedad: 0, kilos: 0, gradoGlucosa: 0, aproxPrice: 0 },
        ]
    ) => {
        return {
            title: `Uva Recibida`,
            headers: [
                'Variedad de Uva',
                'Kilos en Balanza',
                'Grado de Glucosa',
                'Precio por Kg',
            ],
            pagination: 100,
            data: data?.map((dj, i) => {
                return {
                    variedad: grapesVariety?.find(
                        (gv) => gv.codigo === dj.variedad
                    )?.variedad,
                    kilos: (
                        <input
                            className="new_guia-table_input"
                            {...FormMethods.register(
                                `itemsBodega[${i}].kilos` + i
                            )}
                            type={'number'}
                            step="any"
                        />
                    ),
                    gradoGlucosa: (
                        <input
                            className="new_guia-table_input"
                            {...FormMethods.register(
                                `itemsBodega[${i}].grado_Gluc` + i
                            )}
                            type={'number'}
                            step="any"
                        />
                    ),
                    aproxPrice: (
                        <input
                            className="new_guia-table_input"
                            {...FormMethods.register(
                                `itemsBodega[${i}].precio_Kg` + i
                            )}
                            type={'number'}
                            step="any"
                        />
                    ),
                };
            }),
        };
    };

    const [ItemsBodegaTableData, setItemsBodegaTableData] = useState(
        buildItemsBodegaTableData()
    );

    return loader ? (
        <Spinner />
    ) : (
        <>
            <NewGuia
                functions={{
                    ...FormMethods,
                    buildSelectOptions,
                    formatNumber,
                    setOpenConfirmGuiaModal,
                    setOpenDeleteGuiaModal,
                    onSubmit,
                }}
                states={{
                    user,
                    localeDateFormat,
                    ItemsProductorTableData,
                    ItemsBodegaTableData,
                    GuiaData,
                    Bodegas,
                    EstadoDestinatario,
                    EstadoCreada,
                    EstadoCerrada,
                    CurrentBodega,
                    masters,
                    grapesVariety,
                }}
            />
            <Modal
                title={'Confirmar Guía'}
                isOpen={OpenConfirmGuiaModal}
                onClose={() => {
                    FormMethods.resetField('cabecera.firma_Viticultor');
                    setOpenConfirmGuiaModal(!OpenConfirmGuiaModal);
                }}
                questionModal
            >
                {ConfirmGuiaMessage}
            </Modal>
            <Modal
                title={'¿Esta seguro que desea borrar la guía?'}
                isOpen={OpenDeleteGuiaModal}
                onClose={() => setOpenDeleteGuiaModal(!OpenDeleteGuiaModal)}
                questionModal
            >
                {DeleteGuiaMessage}
            </Modal>
        </>
    );
}

export default NewGuiaContainer;
